<template>
  <div>
    <mds-combo-box
      v-if="!isLoadingDataset"
      :label="translate('scheduler.modal.parameters.data.set.label')"
      :data-set="investmentOptions"
      :selected-items="dataset"
      :disabled="!preselectedItem.length || !selectedInvestment"
      @input="onChangeValue"
    />
    <combo-box-loading v-else />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import ComboBoxLoading from '@/components/schedulerModal/schedulerSteps/helpers/ComboBoxLoading.vue'
import { mapOptions } from '@/components/schedulerModal/schedulerSteps/helpers/utils'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'DatasetCombo',
  components: {
    MdsComboBox,
    ComboBoxLoading,
  },
  props: {
    sourceType: {
      type: String,
      default: '',
    },
    investments: {
      type: Object,
      default: () => ({}),
    },
    selectedInvestment: {
      type: String,
      default: undefined,
    },
    editedFeed: {
      type: Object,
      default: () => undefined,
    },
    bindingDataset: {
      type: String,
      default: undefined,
    },
    isLoadingDataset: {
      type: Boolean,
      default: true,
    },
    investmentValueChange: {
      type: Boolean,
      default: false,
    },
    parameterName: {
      type: String,
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      dataset: [],
    }
  },
  watch: {
    selectedInvestment() {
      this.validateDataset()
    },
    bindingDataset: {
      deep: true,
      immediate: true,
      handler() {
        this.validateDataset()
      },
    },
    dataset: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit('datasetChange', value)
      },
    },
  },
  computed: {
    investmentOptions() {
      return this.mappedOptions(this.investments.data_set, this.parameterName)
    },
    preselectedItem() {
      for (const option of this.investmentOptions) {
        if (!isEmpty(option?.children)) {
          return [option.children[0].value]
        }
      }
      return []
    },
  },
  methods: {
    mappedOptions(options, parameterName) {
      const datasetOptions = mapOptions(
        options,
        parameterName,
        this.sourceType,
        this.translate
      )

      if (isEmpty(this.bindingDataset)) {
        const untitledDataset = {
          text: 'Untitled Binding dataset',
          children: [
            {
              text: 'Untitled',
              value: '',
            },
          ],
        }

        datasetOptions.unshift(untitledDataset)
      }

      return datasetOptions
    },
    onChangeValue(e) {
      const [dropdownSelectionId = ''] = e
      this.dataset = [dropdownSelectionId]
    },
    datasetExists(dataSetId) {
      if (isEmpty(dataSetId)) {
        return ''
      }

      for (const dataset in this.investments.data_set) {
        const datasets = this.investments.data_set[dataset]

        const foundDataset = datasets.find((record) => record.id === dataSetId)

        if (foundDataset) {
          return foundDataset.id
        }
      }

      return undefined
    },
    validateDataset() {
      const {
        query: { dataSet = '' },
      } = this.$route ?? {}

      const queryDataSetExists = this.datasetExists(dataSet)
      if (queryDataSetExists && !this.editedFeed) {
        this.dataset = [queryDataSetExists]
        return
      }

      if (
        this.editedFeed &&
        this.editedFeed.data_set &&
        isEqual(this.editedFeed.investment_item, this.selectedInvestment) &&
        !this.investmentValueChange
      ) {
        this.dataset = [this.editedFeed.data_set]
        return
      }

      const bindingDatasetExists = this.datasetExists(this.bindingDataset)
      if (bindingDatasetExists) {
        this.dataset = [bindingDatasetExists]
        return
      }

      this.dataset = this.preselectedItem
    },
  },
}
</script>
